<template>
  <div class="animated fadeIn">
    <div class="page-card-margin row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <strong>{{web_texts.create_invoice_simulation}}</strong>
          </div>
          <div class="card-block">
            <form id="invoice-simulation" enctype="multipart/form-data" class="form-horizontal ">
              <div class="form-group row">
                <div class="col-lg-4 form-group">
                  <label>{{web_texts.date_range}}</label>
                  <div class="input-prepend input-group col-xlg-12 col-md-12 col-sm-12 col-xs-12">
                    <span class="add-on input-group-addon"><i class="glyphicon glyphicon-calendar fa fa-calendar"></i></span>
                    <input type="text" name="daterange" id="daterange" class="form-control input-lg"/>
                  </div>
                </div>
                <div class="col-lg-2 form-group">
                  <label for="user-name">{{web_texts.username}}</label>
                  <input id="user-name" class="form-control input-lg" type="text" v-model="user_name" readonly/>
                </div>
                <div class="col-lg-3 form-group">
                  <div class="col-lg-12">
                    <label for="slave_type">{{web_texts.device_model}}</label>
                    <select v-model="slave_type" id="slave_type" name="slave_type" class="form-control input-lg"
                            size="1" @change="getDeviceNumberAndVariables()">
                      <option disabled value="">{{web_texts.select_model}}</option>
                      <option v-for="slave_type in slave_types" :value="slave_type" v-if="slave_type!=='Irrimation'">
                        {{ slave_type }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-3 form-group">
                  <div class="col-lg-12">
                    <label for="chose_device">{{web_texts.device}}</label>
                    <select v-model="device" id="chose_device" name="chose_device" class="form-control input-lg"
                            size="1" :disabled="!slave_type">
                      <option disabled value="">{{web_texts.select_device}}</option>
                      <option v-for="device in devices" :value="device" v-if="device.type=='CVM' || device.type=='CVMNET' || device.type=='CVMMINI'">{{ device.name }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="card-footer">
            <div class="offset-lg-4 col-lg-4">
              <button @click="createInvoiceReports()" class="btn btn-sm btn-primary" :disabled="spinner_invoice_simulation"><i class="fa fa-dot-circle-o"></i> {{web_texts.create}}</button>
              <button type="reset" @click="resetInvoiceForm()" class="btn btn-sm btn-danger" :disabled="spinner_invoice_simulation"><i class="fa fa-ban"></i>Reset</button>
            </div>
          </div>
        </div>
      </div>
    </div><!--/.row-->

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <strong>{{web_texts.invoice_simulation}}</strong>
          </div>
          <GeneralSpinner v-if="spinner_invoice_simulation"></GeneralSpinner>
          <div class="card-block" v-else="">
            <vue-good-table :columns="columns" :rows="invoices" :paginate="true" :perPage="5">
              <template slot="table-row" slot-scope="props">
                <td>{{ props.row.name }}</td>
                <td>{{ props.row.name_slave }}</td>
                <td>{{ props.row.start_datetime }}</td>
                <td>{{ props.row.end_datetime }}</td>
                <td style="text-align: center">
                  <!--<button type="button" class="btn btn-primary" @click="showInvoice(props.row.id)"><i-->
                    <!--class="fa fa-file-pdf-o"></i></button>-->
                  <button type="button" class="btn btn-primary" @click="downloadInvoice(props.row.id)"><i class="fa fa-file-pdf-o"></i></button>
                  <button type="button" class="btn btn-danger" @click="deleteInformApi(props.row.id)"><i class="fa fa-trash-o"></i></button>
                </td>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import trans_cat from '../translates/cat/InvoiceSimulation';
  import trans_es from '../translates/es/InvoiceSimulation';
  import constants from '../constants';
  import middleware from '../utilities/middlewares';
  import modal from 'vue-strap/src/Modal';
  import GeneralSpinner from './partials/GeneralSpinner.vue';

  export default {
    name: '',
    data() {
      return {
        web_texts: { "create_invoice_simulation": "Crear simulació de factura", "date_range": "Rang de dates", "username": "Nom usuari", "device_model": "Model dispositiu", "select_model": "Tria Model", "device": "Dispositiu", "select_device": "Tria Dispositiu", "create": "Crear", "invoice_simulation": "Simulacions de factura" } ,
        spinner_invoice_simulation: true,
        slave_type: '',
        slave_types: '',
        device: '',
        devices: '',
        user_name: '',
        showInvoiceModal: false,
        months: ['Gener', 'Febrer', 'Març', 'Abril', 'Maig', 'Juny', 'Juliol', 'Agost', 'Stembre', 'Octubre', 'Novembre', 'Desembre'],
        captions: {'ok_button': 'Seleccionar'},
        shortDays: ['dg', 'dl', 'dt', 'dc', 'dj', 'dv', 'ds'],
        invoices: '',
        columns: [
          {
            label: 'Username',
            field: 'name',
            html: true
          },
          {
            label: 'Device',
            field: 'name_slave',
            html: true
          },
          {
            label: 'Start date',
            field: 'start_datetime',
            html: true
          },
          {
            label: 'Final Date',
            field: 'end_datetime',
            html: true
          },
          {
            label: 'Actions',
            field: 'actions',
            html: true
          }
        ]
      }
    },
    components: {
      modal,
      GeneralSpinner
    },
    created() {
      middleware.userIsLoged();
      window.localStorage.setItem('real_time_control', '["invoice_simulation","invoice_simulation"]');
      this.web_texts=middleware.selectTranslation(trans_cat,trans_es);

      this.system = JSON.parse(localStorage.getItem('system'));
      this.user_name = JSON.parse(localStorage.getItem('user')).name;
      this.getSlavesType();
      this.getReportsTable();
    },
    mounted(){
      // inicialitzem daterangepicker
      this.initializeDateRangePicker();
    },
    methods: {
      // Llegir models de dispositiu
      getSlavesType() {
        axios.post(constants.ROOT_URL + '/api/v1/slaves_type', {
          system_id: this.system.id,
          client_device: 'd'
        }).then((response) => {
          this.slave_types = response.data;
        }, (response) => {
          console.log(response);
        });
      },
      // Llegir els dispositius
      getDeviceNumberAndVariables() {
        axios.post(constants.ROOT_URL + '/api/v1/device_name_and_variables', {
          system_id: this.system.id,
          type_slave: this.slave_type,
          client_device: 'd'
        }).then((response) => {
          console.log(response.data);
          this.devices = response.data[0];
        }, (response) => {
          console.log(response.data);
        });
      },
      // Llegir les simulacions de factures
      getReportsTable() {
        axios.post(constants.ROOT_URL + '/api/v1/get_informs', {
          system_id: this.system.id,
          inform_type: 'invoice_simulation',
          client_device: 'd'
        }).then((response) => {
          this.invoices = response.data;
          this.spinner_invoice_simulation = false;
        }, (response) => {
          console.log(response.data);
        });
      },
      // Crear una simulacio de factura per a un dispositiu
      createInvoiceReports() {
        this.spinner_invoice_simulation=true;
        if(this.slave_type !==null && this.device!=='' && document.getElementById('daterange').value!=='-'){
          axios.post(constants.ROOT_URL + '/api/v1/create_inform', {
            system_id: this.system.id,
            inform_type: 'invoice_simulation',
            slave_name: this.device.name,
            name: this.report,
            date_range: document.getElementById('daterange').value,
            slave_channel: "C"+this.device.ch,
            slave_id: this.device.id,
            client_device: 'd'
          }).then((response) => {
            console.log(response.data);
            this.getReportsTable();
            swal({type: 'success', title: 'Informe creat correctament'})
          }, (response) => {
            console.log(response.data);
          });
        }else{
          swal({
            type: 'error',
            title: 'Falta Informació'
          })
        }
      },
      // Reiniciar les dades del formulari
      resetInvoiceForm() {
        location.reload();
        // document.getElementById('invoice-simulation').reset()
      },
      // Descargar una simulacio de factura en pdf
      downloadInvoice(id) {
        this.spinner_invoice_simulation=true;
        axios.get(constants.ROOT_URL + "/api/v1/pdf/invoice_simulation/" + id, {
          responseType: 'arraybuffer'
        }).then((response) => {
          this.spinner_invoice_simulation=false;
          var file = new File([response.data], "Invoice_Simulation_"+id+".pdf", {type: "text/plain;charset=utf-8"});
          FileSaver.saveAs(file);
        }, (response) => {
          console.log(response);
        });
      },
      // Eliminar una simulacio de factura
      deleteInformApi(id){
        this.spinner_invoice_simulation=true;
        axios.post(constants.ROOT_URL + '/api/v1/delete_inform', {
          system_id: this.system.id,
          inform_id: id
        }).then((response) => {
          console.log(response.data);
          this.getReportsTable();
        }, (response) => {
          console.log(response.data);
        });
      },
      // Funcio per a que funcione el datepicker
      initializeDateRangePicker(){
        $(function() {
          var date = new Date();
          var month = date.getMonth();
          var year = date.getFullYear();
          $('input[name="daterange"]').daterangepicker({
            "locale": {
              "format": "DD/MM/YYYY",
              "separator": " - ",
              "applyLabel": "Acceptar",
              "cancelLabel": "Cancel·lar",
              "fromLabel": "Des de",
              "toLabel": "Fins",
              "customRangeLabel": "Custom",
              "weekLabel": "W",
              "daysOfWeek": [
                "dg",
                "dl",
                "dt",
                "dc",
                "dj",
                "dv",
                "ds"
              ],
              "monthNames": [
                "Gener",
                "Febrer",
                "Març",
                "Abril",
                "Maig",
                "Juny",
                "Juliol ",
                "Agost ",
                "Setembre",
                "Octubre",
                "Novembre",
                "Desembre"
              ],
              "firstDay": 1
            },
            "startDate": "1/"+(month+1)+"/"+year,
            "endDate": "28/"+(month+1)+"/"+year
          })
        });
      }

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// InvoiceSimulation.vue?4adf8264